(() => {
  const DRAWER_SELECTOR = [
    '.mr-cart-drawer.is-open',
    '.mr-collection-drawer.is-open'
  ].join(',');

  const KNOWN_CHAT_SELECTOR = [
    '#ShopifyChat',
    '#shopify-chat',
    '.shopify-chat',
    'shopify-chat',
    '[data-shopify-chat]',
    '[id*="shopify-chat" i]',
    '[class*="shopify-chat" i]'
  ].join(',');

  let scheduled = false;

  const getChatElements = () => {
    const elements = new Set(
      document.querySelectorAll(KNOWN_CHAT_SELECTOR)
    );

    document.querySelectorAll('iframe').forEach((iframe) => {
      const title = iframe.getAttribute('title') || '';
      const src = iframe.getAttribute('src') || '';

      const isChat =
        /chat|shopify inbox/i.test(title) ||
        /shopify.?chat|inbox\.shopify/i.test(src);

      if (!isChat) return;

      elements.add(iframe);

      let topLevelElement = iframe;

      while (
        topLevelElement.parentElement &&
        topLevelElement.parentElement !== document.body
      ) {
        topLevelElement = topLevelElement.parentElement;
      }

      elements.add(topLevelElement);
    });

    return elements;
  };

  const update = () => {
    scheduled = false;

    const drawerOpen =
      document.querySelector(DRAWER_SELECTOR) !== null;

    document.documentElement.classList.toggle(
      'mr-commerce-drawer-open',
      drawerOpen
    );

    document.body?.classList.toggle(
      'mr-commerce-drawer-open',
      drawerOpen
    );

    document
      .querySelectorAll('.mr-inbox-hidden-by-drawer')
      .forEach((element) => {
        if (!drawerOpen) {
          element.classList.remove(
            'mr-inbox-hidden-by-drawer'
          );
        }
      });

    if (drawerOpen) {
      getChatElements().forEach((element) => {
        element.classList.add(
          'mr-inbox-hidden-by-drawer'
        );
      });
    }
  };

  const scheduleUpdate = () => {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(update);
  };

  const initialize = () => {
    update();

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'class',
        'aria-hidden',
        'src',
        'title'
      ]
    });

    document.addEventListener(
      'click',
      scheduleUpdate,
      true
    );

    document.addEventListener(
      'keydown',
      scheduleUpdate,
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
